import React from 'react';
import WebLottiePlayer, {WebLottieSource} from '../WebLottiePlayer';
import scaleSize, {isTablet} from '../../utils/scaleSize';
import './WebObjectView.css';

interface WebObjectViewProps {
  sourceImg: WebLottieSource;
  displayText?: string;
  animateObject?: boolean;
  onObjectPress: () => void;
  containerClassName?: string;
  objectClassName?: string;
}

const WebObjectView: React.FC<WebObjectViewProps> = ({
  sourceImg,
  displayText = '',
  animateObject = false,
  onObjectPress,
  containerClassName = '',
  objectClassName = '',
}) => (
  <button
    type="button"
    className={`web-object-view ${containerClassName}`}
    onClick={onObjectPress}
    aria-label={displayText || 'Interactive object'}>
    <WebLottiePlayer
      source={sourceImg}
      className={`web-object-view-lottie ${objectClassName}`}
      autoPlay={animateObject}
      loop={animateObject}
    />
    {displayText && (
      <span
        className="web-object-view-label"
        style={{
          fontSize: scaleSize(20),
          marginLeft:
            displayText.toLowerCase().trim() === 'magic backpack'
              ? isTablet()
                ? '40%'
                : '45%'
              : '70%',
        }}>
        {displayText}
      </span>
    )}
  </button>
);

export default WebObjectView;
